import {
  create as createSelector,
  getIndex as getSelectorIndex,
} from '@spazious/dollhouse-selector';

/**
 * Generate a selector for the given cursor and index
 */
export const generateSelector = (index: number, cursor: string | null = null) => {
  const parent = null;
  const cursorIndex = cursor ? getSelectorIndex(cursor) : 0;
  return createSelector(cursorIndex + index, parent);
};
